import { Fragment, ReactNode } from "react";

import Box from "ds/components/Box";

import { isValidKey } from "../helpers";
import styles from "../styles.module.css";
import { CodeChangesValueNode } from "../types";
import Label from "./Label";
import Prefix from "./Prefix";
import Value from "./Value";

type RowProps = {
  item: CodeChangesValueNode;
};

const SingleRow = ({ children }: { children: ReactNode }) => (
  <Box gap="medium" className={styles.codeChangesSingleRow}>
    {children}
  </Box>
);

const Row = ({ item }: RowProps) => {
  // Covers cases where there is an only change in the section. This overrides the default grid behavior
  const Wrapper = isValidKey(item.key) ? Fragment : SingleRow;

  return (
    <Wrapper>
      <Prefix changeType={item.type} />
      <Label keyName={item.key} />
      <Box gap="medium" wrap className={styles.codeChangesValue}>
        <Value item={item} />
      </Box>
    </Wrapper>
  );
};

export default Row;
